<header #pageHeader class="fixed-top">
    <nav>
        <img src="../../../assets/img/velmaral-banner.jpg" class="img-fluid header-img" alt="Event"
            (load)="onHeaderImageLoad()" decoding="async" />
    </nav>
</header>
<div class="bg-wrapper" #bgWrapper>
    <div class="container-fluid">

        <div class="row mt-3 mb-3">
            <div class="col-12 text-center">
                <h4 class="text-danger fw-bold mt-3">தன்னார்வலர்களுக்கான படிவம் (volunteer Form) </h4>
                <em class="text-danger">தன்னார்வலர்கள் மட்டும் இந்த படிவத்தை பூர்த்தி செய்யவும் (Only volunteers are
                    requested to fill out this form)</em>
            </div>
        </div>

        <!-- Background -->
        <div class="d-flex justify-content-center py-4 px-2">

            <!-- White Card Container -->
            <div class="container form-card p-4">

                <form [formGroup]="volunteerForm" (ngSubmit)="submitForm()" class="p-2">
                    <!-- ====== EVENT NAME ====== -->
                    <div>
                        <div class="form-floating mb-3">
                            <select class="form-select" (change)="selectValue($event)">
                                <option value="">Select a Event Name</option>
                                <option *ngFor="let event of this.eventDetails" [value]="event.eventId">
                                    {{event.eventName}} -
                                    {{event.city}} -
                                    {{formattedDate(event?.eventDate)}}</option>
                            </select>
                            <label for="formId1">Event Name</label>
                        </div>
                    </div>


                    <div class="row" *ngIf="remainingCount != 0">
                        <p class="limited-seat text-center mt-1 mb-1">
                            வேல்மாறல் தன்னார்வலர்கள் பதிவுக்கு இன்னும் <b>{{remainingCount}} இடங்கள்</b> மட்டுமே
                            உள்ளன.
                        </p>
                    </div>

                    <div class="bg-wrapper" #bgWrapper>
                        <div class="" *ngIf="!canShow">
                            <!-- ====== NAME ====== -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">பெயர் (Name) *</label>
                                <input type="text" class="form-control" formControlName="name"
                                    (keypress)="allowOnlyName($event)"
                                    [ngClass]="{'is-invalid': volunteerForm.get('name')?.touched && volunteerForm.get('name')?.invalid}">

                                <div *ngIf="volunteerForm.get('name')?.touched && volunteerForm.get('name')?.invalid"
                                    class="text-error mt-1">
                                    பெயர் அவசியம் தேவை.
                                </div>
                                <div *ngIf="volunteerForm.get('name')?.errors?.['pattern']" class="text-error mt-1">
                                    A-Z எழுத்துகள் மற்றும் . மட்டும் அனுமதிக்கப்படும்.
                                </div>
                            </div>


                            <!-- PHONE -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">தொலைபேசி எண் (Contact Phone Number) *</label>

                                <input type="text" class="form-control" formControlName="phone" maxlength="10"
                                    (input)="onPhoneInput($event, 'phone')" (keypress)="allowOnlyDigits($event)"
                                    (paste)="onPhonePaste($event, 'phone')"
                                    [ngClass]="{'is-invalid': volunteerForm.get('phone')?.touched && volunteerForm.get('phone')?.invalid}" />

                                <div *ngIf="volunteerForm.get('phone')?.touched && volunteerForm.get('phone')?.invalid"
                                    class="text-error mt-1">
                                    <span *ngIf="volunteerForm.get('phone')?.errors?.['required']">தொலைபேசி எண்ணை
                                        உள்ளிடவும்.</span>
                                    <span *ngIf="volunteerForm.get('phone')?.errors?.['pattern']">சரியான 10 இலக்க
                                        எண்ணை உள்ளிடவும்.</span>
                                </div>
                            </div>


                            <!-- WHATSAPP -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">வாட்ஸ் ஆப் எண் (WhatsApp Number) *</label>

                                <input type="text" class="form-control" formControlName="whatsappNumber" maxlength="10"
                                    (input)="onPhoneInput($event,'whatsappNumber')" (keypress)="allowOnlyDigits($event)"
                                    (paste)="onPhonePaste($event,'whatsappNumber')"
                                    [ngClass]="{'is-invalid': volunteerForm.get('whatsappNumber')?.touched && volunteerForm.get('whatsappNumber')?.invalid}" />

                                <div *ngIf="volunteerForm.get('whatsappNumber')?.touched && volunteerForm.get('whatsappNumber')?.invalid"
                                    class="text-error mt-1">
                                    <span *ngIf="volunteerForm.get('whatsappNumber')?.errors?.['required']">வாட்ஸ்அப்
                                        எண்ணை
                                        உள்ளிடவும்.</span>
                                    <span *ngIf="volunteerForm.get('whatsappNumber')?.errors?.['pattern']">சரியான 10
                                        இலக்க
                                        எண்ணை
                                        உள்ளிடவும்.</span>
                                </div>
                            </div>


                            <!-- ====== EMAIL ====== -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">Email *</label>
                                <input type="email" class="form-control" formControlName="email"
                                    placeholder="Enter valid email"
                                    [ngClass]="{'is-invalid': volunteerForm.get('email')?.touched && volunteerForm.get('email')?.invalid}">

                                <div *ngIf="volunteerForm.get('email')?.touched && volunteerForm.get('email')?.invalid"
                                    class="text-error mt-1">
                                    <span *ngIf="volunteerForm.get('email')?.errors?.['required']">Email is
                                        required.</span>
                                    <span *ngIf="volunteerForm.get('email')?.errors?.['email']">Invalid email
                                        format.</span>
                                    <span *ngIf="volunteerForm.get('email')?.errors?.['invalidDomain']">
                                        Only gmail.com, zohomail.com, yahoo.com, hotmail.com, outlook.com allowed.
                                    </span>
                                </div>
                            </div>

                            <div class="mb-3">
                                <label class="form-label fw-bold">மாநிலம் / யூ பிரதேசம் (State / UT) *</label>

                                <br>

                                <select class="form-select form-select-lg p-1" formControlName="state">
                                    <option value="" disabled selected>Select any one</option>
                                    <option *ngFor="let s of statesList" [value]="s.value">
                                        {{ s.label }}
                                    </option>
                                </select>


                                <div *ngIf="volunteerForm.get('state')?.touched && volunteerForm.get('state')?.invalid"
                                    class="text-error mt-1">
                                    மாநிலம் / யூ பிரதேசத்தை உள்ளிடவும்.
                                </div>
                            </div>


                            <!-- ====== DISTRICT ====== -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">மாவட்டம் (District) *</label>

                                <br>
                                <select class="form-select form-select-lg p-1" formControlName="district">
                                    <option value="" disabled selected>Select any one</option>

                                    <option *ngFor="let d of districtList" [value]="d.value">
                                        {{ d.label }}
                                    </option>
                                </select>

                                <div *ngIf="volunteerForm.get('district')?.touched && volunteerForm.get('district')?.invalid"
                                    class="text-error mt-1">
                                    மாவட்டத்தை உள்ளிடவும்.
                                </div>
                            </div>


                            <!-- ====== AGE ====== -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">வயது (Age) *</label>
                                <input type="number" class="form-control" formControlName="age"
                                    (keypress)="allowOnlyAge($event)" maxlength="3">
                                <div *ngIf="volunteerForm.get('age')?.touched && volunteerForm.get('age')?.invalid"
                                    class="text-error mt-1">
                                    <span *ngIf="volunteerForm.get('age')?.errors?.['required']">வயதை உள்ளிடவும்.</span>
                                    <span *ngIf="volunteerForm.get('age')?.errors?.['pattern']">
                                        வயது 1 முதல் 120 வரை இருக்க வேண்டும்.
                                    </span>
                                </div>
                            </div>


                            <!-- ====== PHYSICALLY CHALLENGED ====== -->
                            <div class="mb-3">
                                <label class="form-label fw-bold">பாலினம் (gender)*</label>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" formControlName="gender" value="Male"
                                        id="male">
                                    <label class="form-check-label" for="male">Male</label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" formControlName="gender" value="Female"
                                        id="female">
                                    <label class="form-check-label" for="female">Female</label>
                                </div>

                                <div class="form-check">
                                    <input class="form-check-input" type="radio" formControlName="gender" value="others"
                                        id="others">
                                    <label class="form-check-label" for="others">Others</label>
                                </div>

                                <div *ngIf="volunteerForm.get('gender')?.touched && volunteerForm.get('gender')?.invalid"
                                    class="text-error mt-1">
                                    தயவுசெய்து ஒரு பாலினம் (gender) தேர்வு செய்யவும்.
                                </div>
                            </div>


                            <!-- ====== MAT CARRY RULE ====== -->
                            <div class="instruction-box p-3 my-3">
                                <div class="pledge-container">

                                    <h2>உறுதிமொழி</h2>
                                    <ul class="ms-2">
                                        <li>இந்த நிகழ்ச்சியில் தன்னார்வலர்களாக குழுவில் இருந்து ஒதுக்கப்படும்
                                            எந்தவித பணியாக
                                            இருப்பினும் அதை சிறப்பாக செய்வேன்.</li>
                                        <li>குழுவில் இருந்து ஒதுக்கப்படும் எந்தப் பணியையும் மறுக்க மாட்டேன்.</li>
                                        <li>எந்தவித எதிர்பார்ப்புடனும் சேவை செய்ய மாட்டேன்.</li>
                                        <li>நான் என் வேலைதான் செய்வேன், மற்றவர்களின் வேலைகளில் நான் தலையிடமாட்டேன்.
                                        </li>
                                        <li>நான் தேவையில்லாமல் பேசமாட்டேன்.</li>
                                        <li>நான் எந்தவொரு வாதத்திலும் ஈடுபடமாட்டேன்.</li>
                                    </ul>

                                    <hr />

                                    <h2>Pledge</h2>
                                    <ul class="ms-2">
                                        <li>As a volunteer in this event, I sincerely promise the following:</li>
                                        <li>I will carry out any task assigned to me by the team to the best of my
                                            ability.
                                        </li>
                                        <li>I will not refuse any responsibility assigned by the team.</li>
                                        <li>I will serve without any expectations.</li>
                                        <li>I will focus only on my responsibilities and will not interfere in
                                            others' work.
                                        </li>
                                        <li>I will not engage in unnecessary conversations.</li>
                                        <li>I will not involve myself in any arguments.</li>
                                    </ul>

                                </div>
                            </div>



                            <!-- ====== OPTIONAL CHECKBOX ====== -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="pledgeStatus"
                                        formControlName="pledgeStatus">
                                    <label class="form-check-label" for="pledgeStatus">முழு மனதுடன் மேலே
                                        கொடுக்கப்பட்டுள்ள
                                        உறுதிமொழியை
                                        ஏற்கிறேன். (I wholeheartedly accept the above-mentioned pledge.)</label>
                                </div>

                                <div *ngIf="volunteerForm.get('pledgeStatus')?.touched && volunteerForm.get('pledgeStatus')?.invalid"
                                    class="text-error mt-1">
                                    உறுதிமொழி தேர்வு செய்யவும்.
                                </div>
                            </div>

                            <!-- ====== SUBMIT BUTTON ====== -->
                            <div class="text-center">
                                <button class="btn btn-danger btn rounded-pill px-5 mt-3 ">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="closed-wrapper d-flex justify-content-center align-items-center overflow-y" #bgWrapper *ngIf="canShow">
    <div class="closed-card animate__animated animate__fadeIn" style="margin-top: -140px;">
        <div class="icon-circles">
            <i class="bi bi-x-circle-fill"></i>
        </div>

        <h3 class="tamil-title">பதிவு முடிந்துவிட்டது</h3>
        <h6 class="tamil-text">
            இந்த நிகழ்விற்கான தன்னார்வாளர் பதிவு முடிந்துவிட்டது.<br>
            தயவுசெய்து நிகழ்வு ஏற்பாட்டாளரை தொடர்பு கொள்ளவும்.
        </h6>


        <hr>

        <h4 class="eng-title">Form Closed</h4>
        <h6 class="eng-text">
            This form is no longer accepting responses.<br>
            Please contact the event organizer.
        </h6>
        <h4 class="eng-title">Contact Us: +91 7339663756</h4>
    </div>
</div>

<footer class="real-footer">
    <div class="text-white py-1">
        <div class="container-fluid">
            <div class="row d-flex justify-content-between align-items-center text-center">

                <div class="col-lg-4 col-md-6 col-12 mb-2">
                    <p class="mb-0 josefin-sans-regular">© <b>{{ currentYear }}</b> All rights reserved to <a href=""
                            class="text-white text-decoration-none font-weight-bold">
                            வேல் மாறல் சேவா அறக்கட்டளை.
                        </a></p>
                </div>
                <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center">
                    <p class="mb-0">Designed &amp; Developed by <a href="https://cktechsoln.in/" target="_blank"
                            class="text-white text-decoration-none font-weight-bold">CKTech Solution Pvt Ltd
                            Madurai.</a></p>
                </div>
                <!-- <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center">
          <p class="mb-0"><a routerLink="/terms" target="_blank"
              class="text-white text-decoration-none font-weight-bold">Terms & Conditions</a> | <a routerLink="/privacy"
              target="_blank" class="text-white text-decoration-none font-weight-bold">Privacy</a></p>
        </div> -->
            </div>
        </div>
    </div>

</footer>